// extracted by mini-css-extract-plugin
export var HeroAreaSmall = "HeroAreaSmall-module--HeroAreaSmall--17f9a";
export var image = "HeroAreaSmall-module--image--5b15b";
export var title = "HeroAreaSmall-module--title--6c88d";